import {Component} from "@angular/core";
import {BrowserAgent} from "../services/browser/browser.agent";
import {ActivityModalEvent, ACTIVITY_STATUS} from "../event/ActivityEvent";
import {ComponentBase} from "../base/ComponentBase";
import {Scilearn} from "../constants";
import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import {ClientConfiguration} from "../services/configuration/client.config";
import {MicrophoneService, WeightedDeviceInfo} from "../services/audio/microphone.service";
import {Login} from "../login/login";
import {filter} from "rxjs/operators";
import {UtilitiesService} from "../services/utilities.service";

@Component({
    selector: "sysinfo",
    templateUrl: "./sysinfo.component.html",
    styleUrls: ["./sysinfo.component.scss"]
})

export class SysinfoComponent extends ComponentBase {

    private modalType: string = Scilearn.SYSINFO_MODAL;
    public activeModal: boolean = false;
    public browser: string;
    public screenResolution: string;
    public slcLocation: string;
    public learnerName: string;
    public audioDevices: WeightedDeviceInfo[];
    public currentAudioDevice: string;
    public operatingSystem: string;
    public audioContext: AudioContext;
    public version: string;

    constructor(private modalConfig:ModalConfig,
                private eventBus:EventBus,
                private browserAgent: BrowserAgent,
                private config: ClientConfiguration,
                private microphoneService: MicrophoneService,
                private login: Login
                ) {
        super("SysinfoComponent");
        this.listenToModalEvents();
    }

    private listenToModalEvents(): void {
        // event filter for user clicking a link to display
        let activitySubscription = this.eventBus.pipe(filter(event => event instanceof ActivityModalEvent)).subscribe((event:ActivityModalEvent) => {
            if (event.status === ACTIVITY_STATUS.modal_open && event.data.type === this.modalType) {
                this.loadInfo();
                this.openModal();
            }
        });

        this.subscriptions.push(activitySubscription);
    }

    private loadInfo(): void {
        this.browser = this.browserAgent.getFullBrowserInfo();
        this.screenResolution = screen.width + " x " + screen.height;
        this.slcLocation = this.config.baseAPIPath;
        this.learnerName = this.login.name;
        this.audioDevices = this.microphoneService.getAudioDevices();
        this.currentAudioDevice = this.microphoneService.audioDeviceNameInUse;
        this.audioContext = this.microphoneService.getAudioContext();
        this.operatingSystem = this.browserAgent.getOperatingSystemInfo();
        this.version = UtilitiesService.getVersion();
    }

    private openModal(): void {
        this.activeModal = true;
    }

    public closeModal(): void {
        this.activeModal = false;
    }

}
